export default "__VITE_ASSET__DwdQ_8Ys__"